export const LISTA_COLORES_ICONOS = {
    BLUE_ACTIVO: "#007bc7",
    GRAY_INACTIVO: "#D1D8E0",
    DARK_GRAY: "#38485C",
    ERROR: "#C93B3B",
} as const;